// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright_copyright__5Hn5X"};